import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "hometext" }, "Portrait of the year 2022: Annie Lööf at court against Theodor Engström ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "portfolioBox" }
const _hoisted_5 = {
  id: "Weddings",
  class: "portfolioItem"
}
const _hoisted_6 = {
  id: "Redactional",
  class: "portfolioItem"
}
const _hoisted_7 = {
  id: "Portraits",
  class: "portfolioItem"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GalleryImages = _resolveComponent("GalleryImages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "background",
      style: _normalizeStyle({ 'background-image': 'url('+ _ctx.image + ')' })
    }, _hoisted_3, 4),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_GalleryImages, {
          prismicType: "wedd",
          size: "medium"
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_GalleryImages, {
          prismicType: "redac",
          size: "medium"
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_GalleryImages, {
          prismicType: "portrait",
          size: "medium"
        })
      ])
    ])
  ]))
}